import { render, staticRenderFns } from "./checkPageVip1.vue?vue&type=template&id=39b64f70&scoped=true&"
import script from "./checkPageVip1.vue?vue&type=script&lang=js&"
export * from "./checkPageVip1.vue?vue&type=script&lang=js&"
import style0 from "./checkPageVip1.vue?vue&type=style&index=0&id=39b64f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b64f70",
  null
  
)

export default component.exports